import background from "./background.png";
import logo from "./logo.jpg";
import andy from "./andy-mascot.png";

export const Images = {
  background,
  logo,
  andy,
};

